const isStringWithSpecial =
  (message = 'Please enter a string') =>
  (value: any) => {
    const regex = /^[-@.,'/#&+!(){}\d\s\w\u00C0-\u017F\u0430-\u044f]*$/iu;
    return regex.test(value || '') || message;
  };

export default isStringWithSpecial;
